module.exports = __webpack_public_path__ + "images/category_lp/common/reason1-man-30@2x_fbdd736a83b7022bbe4f20d2f5523fb3.jpg";